import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";

import logo from "../trumper.png";
import logo_wide from "../trumper_wide.png";

/*const playAudio = () => {
  const ran = Math.floor(Math.random() * 2) + 1;
  console.log(ran);
  const fired = new Audio("http://192.168.178.50:3000/fired.mp3");
  const wrong = new Audio("http://192.168.178.50:3000/wrong.mp3");
  fired.volume = 0.5;
  wrong.volume = 0.5; a

  if (ran == 1) fired.play();
  if (ran == 2) wrong.play();
};*/

export default class Sidebar extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div class="sidebar">
        <img
          title="Trumper | 120x better than Twitter"
          width="35"
          src={logo}
          alt="Trumper "
          className="logo"
        />

        <ul>
          <li>
            <Link to="/">
              <i className="bi bi-house-door"></i> Home
            </Link>
          </li>
          <li className="disabled">
            <i className="bi bi-hash"></i> Explore
          </li>
          <li className="disabled">
            <i className="bi bi-bell"></i> Notifications
          </li>
          <li className="disabled">
            <i className="bi bi-envelope"></i> Messages
          </li>
          <li className="disabled">
            <i className="bi bi-bookmark"></i> Bookmarks
          </li>
          <li className="disabled">
            <i className="bi bi-person"></i> Profile
          </li>
        </ul>
        <Link to="/">
          <button
            onClick={() => {
              const tweetInput = document.querySelector(
                "#root > div.app > div.main > div > div.postContainer > div.inputBox > input[type=text]"
              );

              if (tweetInput) {
                window.location.href = "#writeTweet";
                tweetInput.select();
              }
            }}
            className="tweet"
          >
            Trump
          </button>
        </Link>
      </div>
    );
  }
}
